<template>
    <img :src="src" :srcset="srcset"  :alt="alt"/>
</template>

<script>
export default {
    name: "ImageTag",
    components: {},
    props: {
        src: String,
        alt: {
            type: String,
            default: ''
        },
        // image size "2x" to use in attribute srcset
        // example to use double of current image size:
        //  {
        //      double: true
        //  }
        // example to use double of current, but only if lower than 300px:
        //  {
        //      double: true,
        //      max: 200
        //  }
        // example to use 200px as width and height: 
        //  {
        //      size: 200
        //  }
        size2x: {
            type: [Boolean, Number, Object], 
            default: () => {
                return {double:true};
            }
        },
    },
    data: function () {
        let options = null;
        if(typeof this.size2x === 'boolean' && this.size2x){
            // double size
            options = {double: true};
        }
        else if(typeof this.size2x === 'number' && this.size2x > 0){
            // use specific size
            options = {size: this.size2x};
        }    
        else if(typeof this.size2x === 'object'){
            // double size
            options = this.size2x;
        }

        return {
            size2xOptions: options
        };
    },
    computed: {
        srcset(){
            //console.log('size2x values ', this.size2x, this.size2xOptions);
            const options = this.size2xOptions;
            if(!options){
                return null;
            }
            let w = 0, h = 0, max = 0;
            const regex = /\/thumb\/([\d]+)\/([\d]+)\/products\//;

            if(options.hasOwnProperty('double') && options.double){
                let m;
                if ((m = regex.exec(this.src)) !== null) {
                    w = m[1] * 2;
                    h = m[2] * 2;
                }                        
            }

            if(options.hasOwnProperty('size') && options.size > 0){
                w = h = options.size;
            }

            if(options.hasOwnProperty('max') && options.max > 0){
                if(w > options.max || h > options.max){
                    return null;
                }
            }

            if(w && h){
                const subst = '/thumb/'+w+'/'+h+'/products/';
                //console.log('size2x result: ', this.src.replace(regex, subst));
                return this.src.replace(regex, subst) + ' 2x';
            }

            return null;
        }
    }
};
</script>
